import Styled from 'styled-components';

const FormRow = Styled.div`
  display: flex;
  margin: 0 0 1.714em; /* 24px */
  overflow: auto;
`;

export default FormRow;
